import { z } from "@/zod";
import { PresignOperation } from "./types";

export const presignApiRequestSchema = z.object({
  attachment_id: z.string().optional(),
  filename: z.string().min(1).max(255),
  field_name: z.string(),
  operation: z.enum(["put", "delete"] as [PresignOperation, PresignOperation]),
});

export const presignApiResponseSchema = z.object({
  data: z.object({
    attachment_id: z.string(),
    filename: z.string(),
    field_name: z.string(),
    s3_key: z.string(),
    presigned_url: z.string(),
    operation: z.enum(["put", "delete"] as [
      PresignOperation,
      PresignOperation,
    ]),
    content_type: z.string().optional(),
    create_only: z.boolean().optional(),
    metadata: z
      .object({
        confirmed_at: z.string().nullable().optional(),
      })
      .optional(),
  }),
  message: z.string().optional(),
});
